import React, {useState, useEffect} from "react";
import {createPortal} from "react-dom";
import {IoMdClose} from "react-icons/io";

import {
  BackContainer,
  ButtonsContainer,
  CloseButton,
  Container,
  ContentContainer,
  FullLoader,
  FullLoaderContainer,
  HeaderContainer,
  MainButton,
  SignatureCheckbox,
  SignatureContainer,
  SignatureImage,
  SignatureName,
  SignatureSubtitle,
  SignatureTextContainer,
  SignaturesContainer,
} from "./styles";
import { producaov2 } from "../../../../../../services/apis";
import { getNodeToken } from "../../../../../../services/auth_node";

function SignatureItem({
  id,
  title,
  subtitle,
  image,
  config,
  isSelected,
  onChangeSelection
}) {

  return (
    <SignatureContainer isSelected={isSelected}>
      <SignatureImage src={image} config={config} />
      <SignatureTextContainer>
        <SignatureName>{title}</SignatureName>
        <SignatureSubtitle>{subtitle}</SignatureSubtitle>
      </SignatureTextContainer>
      <SignatureCheckbox
        type="checkbox"
        checked={isSelected}
        onChange={onChangeSelection}
      />
    </SignatureContainer>
  );
}

function SignaturesList({
  selectedSignatures,
  onChangeSelectedSignature
}) {
  const [signatures, setSignatures] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const getSignatures = async () => {
      setIsLoading(true);

      try {
        const response = await producaov2.get('/admin/certificate/signatures', {
          headers: {
            access_token: `voitto-token ${getNodeToken()}`
          }
        });

        setSignatures(response.data?.signatures);
      } catch(error) {
        console.log(error);
      }
      finally {
        setIsLoading(false);
      }
    }

    getSignatures();

  }, []);

  if(isLoading) {
    return (
      <FullLoaderContainer>
        <FullLoader></FullLoader>
      </FullLoaderContainer>
    )
  }

  return (
    <>
      <SignaturesContainer>
        {signatures?.map(signature => {
          return (
            <SignatureItem
              {...signature}
              onChangeSelection={() => onChangeSelectedSignature(signature)}
              isSelected={selectedSignatures?.find(selectedSignature => selectedSignature?.id === signature?.id)}  
            />
          )
        })}
      </SignaturesContainer>
    </>
  );
}

/**
 * @todo Adicionar paginação
 * @todo Adicionar campo para buscar pelo nome
 */
export default function SignaturesListModal({
  initialSelectedSignatures = [],
  onSubmit,
  onClose
}) {
  const [selectedSignatures, setSelectedSignatures] = useState(initialSelectedSignatures);

  const onChangeSelectedSignature = (signature) => {
    setSelectedSignatures(prev => {
      const selectedSignature = prev?.find(prevSignature => prevSignature?.id === signature?.id);

      if(selectedSignature) {
        return prev?.filter(prevSignature => prevSignature?.id !== signature?.id);
      }

      return [...prev, signature];
    })
  }

  const onCloseModal = () => {
    onClose();
  }

  const onSubmitSignatures = () => {
    onSubmit(selectedSignatures);
    onCloseModal();
  }
  
  return createPortal(
    <Container>
      <BackContainer onClick={onCloseModal}>
        <ContentContainer onClick={(e) => e?.stopPropagation()}>
          <HeaderContainer>
            <CloseButton onClick={onCloseModal}>
              <IoMdClose size="1.5em" />
            </CloseButton>
          </HeaderContainer>
          <SignaturesList
            selectedSignatures={selectedSignatures}
            onChangeSelectedSignature={onChangeSelectedSignature}
          />
          <ButtonsContainer>
            <MainButton onClick={onSubmitSignatures} disabled={selectedSignatures?.length === 0}>Selecionar assinaturas</MainButton>
          </ButtonsContainer>
        </ContentContainer>
      </BackContainer>
    </Container>,
    document.body
  );
}